export default "__VITE_ASSET__CKT5rktq__"